import {connect} from 'react-redux';
import Actions from '@/Actions';
import UI from './NavBarUI';

const mapStateToProps = (state, ownProps) => {
    let section = state.app.section;
    let sectionType = section.preset;

    return {
        sectionNumber: section.sort_order,
        sectionType: sectionType,
        sectionTitle: section.title,
        backButton: !section.disableNavigation && section.sort_order > 1,
        atEnd: section.at_end,
        disableNavigation: section.disableNavigation,
        lostConnection: sectionType === 'test' && (state.autoSave.failedSavesCount > 0 || state.app.connection_lost),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        navigateBack: () => dispatch(Actions.navigateBack()),
        navigateNext: () => dispatch(Actions.submit()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UI);
